export default {
  computed: {
    $config_domain() {
      return document.location.hostname;
    },
    $config_appName() {
      const name = document.location.hostname;
      if (name.substring(0, 4) !== 'admin.') {
        return 'DEVELOPMENT';
      }
      return name.substring(4, name.length).toUpperCase();
    },
  },
};
